import { Button, Card } from '@safetyhub/ui';
import Modal from '../Modal';

export interface ExistingOrganizationInfo {
  id: string;
  name: string;
  category?: string;
  createdAt?: string;
}

interface CompanyDuplicateErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  existingOrganization?: ExistingOrganizationInfo | null;
}

/**
 * ORGANIZATION_DUPLICATE_COMPANY 에러 전용 모달.
 * FULLY_VERIFIED Company가 이미 다른 조직 본사로 참조 중일 때 표시.
 *
 * 결정 기록: docs/decisions/2026-04-18-company-org-scoped-model.md
 */
export default function CompanyDuplicateErrorModal({
  isOpen,
  onClose,
  existingOrganization,
}: CompanyDuplicateErrorModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="이미 등록된 사업자입니다"
      size="sm"
      footer={
        <Button variant="primary" onClick={onClose}>
          확인
        </Button>
      }
    >
      <div className="space-y-3 p-1">
        <p className="text-sm text-ink-700">
          같은 조직 담당자라면 기존 Owner에게 초대 요청을, 지점/지사/부서라면 기존
          조직의 Group 기능을 이용하세요.
        </p>
        {existingOrganization?.name && (
          <Card padding="sm" surface="soft" elevation="none">
            <p className="text-xs text-ink-500">기존 등록 조직</p>
            <p className="text-sm font-medium text-ink-900 mt-0.5">
              {existingOrganization.name}
            </p>
          </Card>
        )}
      </div>
    </Modal>
  );
}
